import LatestEventsBlock from "../common/blocks/LatestEventsBlock";
const Events = () => {
	return (
	<div className="section-full latest-blog bg-gray p-t100 p-b70">
		{/* <!-- BLOG CONTENT START --> */}
		<LatestEventsBlock />
		{/* <!-- BLOG CONTENT END --> */}
	</div>
	);
};
export default Events;